<div class="content">
  <ion-toggle
    [disabled]="toggleIsDisabled"
    [checked]="toggleIsOn"
    (ionChange)="setToggle($event)"
    aria-labelledby="usf-pme-toggle"
  ></ion-toggle>
  <ion-label id="usf-pme-toggle"
    >{{ 'i18n.lists.pmeList.nextWeekPricing' | translate }}: {{ sundayDate }} -
    {{ saturdayDate }}</ion-label
  >
</div>
